import React, { useEffect, useRef, useState } from "react";
import "./Contact.css";

export default function Contact() {
    const targetRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            setIsVisible(entry.isIntersecting);
        });

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const className = "Contact hidden " + (isVisible ? "show" : "");

    return (
        <section ref={targetRef} className={className} id="contact">
            <h1 className="title">Book a Consultation</h1>
            <p className="contact-subtitle">
                Tell us what your business is trying to improve, and we will follow up with a practical next step.
            </p>
            <div className="contact-card">
                <a className="contact-email" href="mailto:gramlichsoftware@gmail.com">
                    gramlichsoftware@gmail.com
                </a>
                <a className="contact-booking" href="https://calendar.app.google/YtNYViW1QVB9m5Xv6" target="_blank" rel="noreferrer">
                    Book a Consultation
                </a>
                <div className="contact-topics">
                    <h3>What you can ask about</h3>
                    <ul>
                        <li>Website build or redesign</li>
                        <li>Automation idea</li>
                        <li>AI assistant or internal tool</li>
                        <li>
                            AI virtual receptionist &mdash;{" "}
                            <a
                                href="https://reception.rileygramlich.dev"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                try the demo
                            </a>
                        </li>
                        <li>Agent building on OpenClaw or Hermes</li>
                        <li>Software cleanup</li>
                        <li>Digitizing office workflows</li>
                    </ul>
                </div>
            </div>
        </section>
    );
}
